import '@babel/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'

// Store
import { Provider } from 'react-redux'
import { store } from './store'

// Stylesheets
import 'antd/dist/antd.css'
import './resources/styles/app.css'

// Entry point
import App from './App'

// import dotenv from 'dotenv'
// dotenv.config()

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('.app')
)



// WEBPACK FOOTER //
// ./src/index.js